<template>
  <div id="close" class="main">
    <div id="banner">
      <img :src="bannerImg?bannerImg:'static/img/banner.png'" />
    </div>
    <div v-html="cTip" class="closeTip"></div>
    <Footer />
  </div>
</template>
<script>
import Footer from '../components/Footer'
export default {
  name: 'Close',
  components: {
    Footer
  },
  data() {
    return {
      bannerImg: sessionStorage.getItem('bannerImg') || '',
      ExhID: sessionStorage.getItem('ExhID'),
      cTip: sessionStorage.getItem('ClosedTip') || '本届展会已结束'
    }
  },
  mounted() {
    var _this = this
    if (!sessionStorage) {
      _this.$alert('您的浏览器版本过低，请升级您浏览器！', '提示！')
    }
  },
  methods: {}
}
</script>
<style scoped>
#banner img {
  width: 100%;
}
.closeTip{
  min-height: 400px;
  padding: 30px 10px;
  text-align:center;
  background:#fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/Close.vue